module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"signin":"Sign In","signup":"Sign Up","contactSupport":"Contact Support"}}')
  delete Component.options._Ctor
}
